import { Component, Input } from '@angular/core';

@Component({
    selector: 'ca-separator',
    templateUrl: './separator.component.html',
    styleUrls: ['./separator.component.scss'],
    standalone: false
})
export class CaSeparatorComponent {}
